import { defineComponent as a, useCssModule as i, createElementBlock as n, openBlock as c, normalizeClass as t, unref as o, createCommentVNode as l, createElementVNode as p, renderSlot as r } from "vue";
const d = "cdr-chip", f = /* @__PURE__ */ a({
  name: "CdrChip",
  __name: "CdrChip",
  setup(m) {
    const s = i();
    return (e, u) => (c(), n("button", {
      class: t(o(s)[d])
    }, [e.$slots["icon-left"] ? (c(), n("span", {
      key: 0,
      class: t(o(s)["cdr-chip__icon-left"])
    }, [r(e.$slots, "icon-left")], 2)) : l("", !0), e.$slots["icon-right"] ? (c(), n("span", {
      key: 1,
      class: t(o(s)["cdr-chip__icon-right"])
    }, [r(e.$slots, "icon-right")], 2)) : l("", !0), p("span", {
      class: t(o(s)["cdr-chip__content"])
    }, [r(e.$slots, "default")], 2)], 2));
  }
});
export {
  f as default
};
